import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, CONTACT, LOGO } from "../mock";

const scrollTo = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Footer = () => {
  return (
    <footer className="bg-[var(--ink)] text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 max-w-sm">
            <div className="flex items-center gap-3">
              <img
                src={LOGO.icon}
                alt="Sago Industries"
                className="h-11 w-auto"
              />
              <span className="font-heading text-xl font-extrabold tracking-tight text-white">
                Sago<span className="text-[var(--accent)]">Industries</span>
              </span>
            </div>
            <p className="mt-5 leading-relaxed text-white/60">
              Your trusted sourcing partner in India. We connect global buyers with vetted manufacturers, ensuring quality, transparency and seamless delivery.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-bold">Quick Links</h4>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} onClick={(e) => scrollTo(e, l.href)} className="text-white/60 transition-colors hover:text-[var(--accent)]">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-bold">Contact</h4>
            <ul className="mt-4 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={18} className="mt-0.5 shrink-0 text-[var(--accent)]" />
                <a href={`tel:${CONTACT.phone}`} className="text-white/70 hover:text-white">{CONTACT.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="mt-0.5 shrink-0 text-[var(--accent)]" />
                <a href={`mailto:${CONTACT.email}`} className="text-white/70 hover:text-white break-all">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 shrink-0 text-[var(--accent)]" />
                <span className="text-white/70">{CONTACT.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-white/50">© {new Date().getFullYear()} Sago Industries. All rights reserved.</p>
          <p className="text-sm text-white/50">Sourcing goods in India — with confidence.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
